import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import type { Breadcrumb } from '@/types/breadcrumbs/Breadcrumb'
import { useLocalizedRouter } from '@/composables/localizedRouter'

export const useBreadcrumbStore = defineStore('breadcrumbs', () => {
  const _breadcrumbs = ref<Breadcrumb[]>([])
  const {localizedRoute} = useLocalizedRouter()

  const breadcrumbs = computed<Breadcrumb[]>(() => {
    return [
      {
        name: 'Home',
        route: localizedRoute({name: 'home'}),
      },
      ..._breadcrumbs.value,
    ]
  })

  const setBreadcrumbs = (values: Breadcrumb[]) => {
    _breadcrumbs.value = values
  }

  return {
    breadcrumbs,
    setBreadcrumbs,
  }
}, {persist: false})
